import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {GoogleAuthService} from '../services/google-auth-service';

export const authenticatedGuard: CanActivateFn = async (_, state) => {
  const auth = inject(GoogleAuthService);
  const router = inject(Router);

  await auth.authService.authStateReady();

  if (auth.currentUser()) {
    return true;
  }

  auth.setPendingRedirectUrl(state.url);

  return router.createUrlTree(['/signup'], {
    queryParams: {
      returnUrl: state.url,
    },
  });
};
